import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ShieldCheck, UserCircle, Calendar, CheckCircle2, ArrowRight, Lock } from 'lucide-react';
import './PortalPage.css';

const PortalPage = () => {
  const navigate = useNavigate();

  return (
    <div className="portal-page">
      {/* Back Button */}
      {/* <button className="back-home" onClick={() => navigate('/')}>← Back to Home</button> */}

      <div className="portal-hero">
        <div className="med-logo-container">
          <div className="med-logo">🏥 MedConnect</div>
        </div>
        <h1 className="animate-fade-down">Join Our Network of Professional Healthcare Providers</h1>
      </div>

      <div className="portal-grid">
        <div className="portal-card animate-card">
          <UserCircle className="card-icon" size={40} />
          <h3>Professional Profile</h3>
          <p>Showcase your expertise to thousands of patients.</p>
        </div>

        <div className="portal-card animate-card">
          <Calendar className="card-icon" size={40} />
          <h3>Appointment Management</h3>
          <p>Smart scheduling and patient management tools.</p>
        </div>

        <div className="portal-card animate-card">
          <ShieldCheck className="card-icon" size={40} />
          <h3>Secure Platform</h3>
          <p>HIPAA-compliant secure communication.</p>
        </div>
      </div>

      <div className="why-join-container animate-fade-up">
        <h2>Why Join Us?</h2>
        <div className="benefits-grid">
          {[
            "Reach more patients in your area",
            "Manage your online presence",
            "Secure patient communication",
            "Easy appointment scheduling",
            "Monthly performance analytics"
          ].map((text, i) => (
            <div key={i} className="benefit-item">
              <CheckCircle2 size={20} className="check-icon" />
              <span>{text}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="cta-section animate-fade-up">
        <h2>Ready to Get Started?</h2>
        <p>Complete your registration in just 10 minutes</p>
        
        {/* Ispe click karke hum Registration Form page par jayenge */}
        <button className="start-btn" onClick={() => navigate('/register')}>
          Start Registration <ArrowRight size={22} />
        </button>

        <p className="login-footer">Already have an account? <span className="login-link">Log in here</span></p>
        <p className="secure-footer"><Lock size={14} /> All information is securely encrypted</p>
      </div>
    </div>
  );
};

export default PortalPage;